module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_lung_cancer-f5ffa28d1b76d00f1d6f7259807ab41b.png";